/* AZ & CO v17, the boutique room: the little that moves.

   1. Scroll reveals: pieces marked data-reveal rise in once, as they enter.
   2. The hero: four featured bottles, one at a time (every 7 s, paused on
      hover, focus, a hidden tab, and never for reduced motion).
   3. The phone menu.
   4. The masthead tucks away reading down and comes back reading up.
   5. Just landed: each niche takes its bottle's colour, mixed most of the
      way back toward the wall.
   6. The WhatsApp button steps aside over the footer.
   7. The bag number gives a small bump when something is added.

   Nothing here is needed to shop: with no script every bottle, price and
   button is still on the page (the head script only hides reveal pieces
   once it knows this file is coming, and gives them back if it fails). */
(function () {
  'use strict';
  var root = document.documentElement;
  window.AZROOM = true;
  var still = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* 0 ---------------------------------------------------------- texts reveal
     transitions.dev 18: every section's heading block rises line by line
     with a soft blur, 40 ms apart (small line, each heading line, the
     paragraph, then the buttons). The hero plays on load, the rest as they
     scroll in. */
  var stagger = function (box) {
    if (!box || box.dataset.staggered) return null;
    box.dataset.staggered = 1;
    box.removeAttribute('data-reveal');
    var n = 0;
    var mark = function (el) {
      el.removeAttribute('data-reveal');
      el.classList.add('t-stagger-line');
      el.style.setProperty('--n', n++);
    };
    $$('.room-k, .room-h2, .rh-h, .room-p, .rh-p, .rl-when, .rh-act, .rs-aside > .pill, .rg-copy > .pill, .rk-copy > .pill, .rp-n, .rp-line, .rp-act', box).forEach(function (el) {
      if (el.matches('.room-h2, .rh-h')) {
        el.removeAttribute('data-reveal');
        var parts = el.innerHTML.split(/<br\s*\/?>/i);
        el.innerHTML = parts.map(function (h) { return '<span class="t-stagger-line" style="--n:' + (n++) + '">' + h.trim() + '</span>'; }).join('');
      } else mark(el);
    });
    $$('[data-reveal]', box).forEach(function (el) { el.removeAttribute('data-reveal'); });
    box.classList.add('t-stagger');
    return box;
  };
  var heads = ['.rh-copy', '.rs-head', '.rc-head', '.rl-head', '.rg-copy', '.rq-head', '.rk-copy', '.rp-copy', '.pdp-notes', '.page-head'];
  if (!still) {
    var ho = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { ho.unobserve(e.target); e.target.classList.add('is-shown'); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }) : null;
    heads.forEach(function (sel) {
      $$(sel).forEach(function (box) {
        if (!stagger(box)) return;
        if (box.matches('.rh-copy') || !ho) requestAnimationFrame(function () { requestAnimationFrame(function () { box.classList.add('is-shown'); }); });
        else ho.observe(box);
      });
    });
  }

  /* 1 ---------------------------------------------------------- reveals */
  var pieces = $$('[data-reveal]');
  if (!('IntersectionObserver' in window) || still) {
    pieces.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    pieces.forEach(function (el) { io.observe(el); });
  }

  /* transitions.dev 34: soft text swap (old blurs out, new blurs in) */
  var cssMs = function (name) { return parseFloat(getComputedStyle(root).getPropertyValue(name)) || 0; };
  var softSwap = function (el, next) {
    var prev = el.dataset.text || el.textContent;
    if (prev === next) return;
    if (still) { el.textContent = next; el.dataset.text = next; return; }
    el.dataset.text = next;
    el.classList.add('t-text-soft');
    clearTimeout(el._softTimer);
    var out = document.createElement('span'); out.className = 't-text-soft-old'; out.setAttribute('aria-hidden', 'true'); out.textContent = prev;
    var inn = document.createElement('span'); inn.className = 't-text-soft-new'; inn.textContent = next;
    var w0 = el.getBoundingClientRect().width;
    el.classList.remove('is-swapping');
    el.replaceChildren(out, inn);
    var w1 = inn.getBoundingClientRect().width;
    el.style.width = w0 + 'px';
    void el.offsetWidth;
    el.classList.add('is-swapping');
    el.style.width = w1 + 'px';
    el._softTimer = setTimeout(function () {
      el.classList.remove('is-swapping'); el.style.removeProperty('width'); el.textContent = next;
    }, Math.max(cssMs('--text-soft-dur'), cssMs('--text-soft-resize-dur')) + 40);
  };

  /* 2 ---------------------------------------------------------- hero */
  var hero = $('[data-room-hero]');
  if (hero) {
    var slides = $$('.rh-slide', hero);
    var metas = $$('.rh-meta', hero);
    var at = $('[data-room-at]', hero);
    var next = $('[data-room-next]', hero);
    var cur = 0, timer = 0, held = false, busy = false;

    var warm = function (i) {
      var s = slides[i];
      if (!s || s.dataset.warm) return;
      s.dataset.warm = 1;
      $$('img', s).forEach(function (img) { img.loading = 'eager'; });
    };

    var show = function (to) {
      if (busy || to === cur || !slides[to]) return;
      busy = true;
      hero.classList.add('is-cycled');
      var a = slides[cur], b = slides[to], ma = metas[cur], mb = metas[to];
      warm(to);
      a.removeAttribute('data-on');
      a.setAttribute('aria-hidden', 'true');
      a.tabIndex = -1;
      a.classList.add('is-out');
      b.classList.add('is-in');
      b.setAttribute('data-on', '');
      b.removeAttribute('aria-hidden');
      b.removeAttribute('tabindex');
      if (ma && mb) {
        ma.hidden = true;
        mb.classList.add('is-in');
        mb.hidden = false;
      }
      void b.offsetWidth;
      b.classList.remove('is-in');
      if (mb) mb.classList.remove('is-in');
      if (at) softSwap(at, ('0' + (to + 1)).slice(-2));
      cur = to;
      warm((to + 1) % slides.length);
      setTimeout(function () { a.classList.remove('is-out'); busy = false; }, 540);
    };

    var tick = function () {
      clearTimeout(timer);
      if (still || held || document.hidden || slides.length < 2) return;
      timer = setTimeout(function () { show((cur + 1) % slides.length); tick(); }, 7000);
    };

    if (next) next.addEventListener('click', function () {
      show((cur + 1) % slides.length);
      tick();
    });
    hero.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { held = true; clearTimeout(timer); } });
    hero.addEventListener('pointerleave', function () { held = false; tick(); });
    hero.addEventListener('focusin', function () { held = true; clearTimeout(timer); });
    hero.addEventListener('focusout', function () { held = false; tick(); });
    document.addEventListener('visibilitychange', tick);
    // the second bottle's file comes in once the page has settled
    setTimeout(function () { warm(1); }, 2500);
    tick();
  }

  /* 3 ---------------------------------------------------------- menu */
  var mast = $('#room-mast');
  var menu = $('#room-menu');
  var setMenu = function (open) {
    if (!mast || !menu) return;
    menu.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) mast.setAttribute('data-open', ''); else mast.removeAttribute('data-open');
  };
  if (menu) {
    menu.addEventListener('click', function () { setMenu(menu.getAttribute('aria-expanded') !== 'true'); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && mast.hasAttribute('data-open')) { setMenu(false); menu.focus(); } });
    document.addEventListener('click', function (e) { if (mast.hasAttribute('data-open') && !mast.contains(e.target)) setMenu(false); });
  }

  /* 4 ---------------------------------------------------------- masthead */
  if (mast && !still) {
    var lastY = scrollY, ticking = false;
    addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = scrollY;
        var down = y > lastY + 4, up = y < lastY - 4;
        if (mast.hasAttribute('data-open') || y < 160 || up) mast.removeAttribute('data-tucked');
        else if (down) mast.setAttribute('data-tucked', '');
        if (down || up) lastY = y;
        ticking = false;
      });
    }, { passive: true });
    // a bag or search panel opening always brings it back
    mast.addEventListener('focusin', function () { mast.removeAttribute('data-tucked'); });
  }

  /* 5 ---------------------------------------------------------- niches
     Each niche is painted in its bottle's own colour, deep and saturated
     (the Figma "Just landed" look): the bottle's dominant hue is found from
     a 64 px copy (hue histogram, weighted by how coloured each pixel is),
     then set at a fixed depth so every niche has the same weight on the
     wall. A clear or black-and-white bottle gets slate. */
  var hsl = function (h, s, l) { return 'hsl(' + Math.round(h) + ' ' + Math.round(s * 100) + '% ' + Math.round(l * 100) + '%)'; };
  var tint = function (el, c) {
    el.style.setProperty('--n1', hsl(c[0], c[1], c[1] < 0.2 ? 0.33 : 0.36));
    el.style.setProperty('--n2', hsl(c[0], c[1] * 0.85, 0.18));
  };
  var sample = function (img) {
    var w = 48, h = 64, cv = document.createElement('canvas');
    cv.width = w; cv.height = h;
    var cx = cv.getContext('2d', { willReadFrequently: true });
    cx.drawImage(img, 0, 0, w, h);
    var d = cx.getImageData(0, 0, w, h).data, bins = [], sx = [], sy = [], ss = [], tot = 0, all = 0, i;
    for (i = 0; i < 36; i++) { bins[i] = 0; sx[i] = 0; sy[i] = 0; ss[i] = 0; }
    for (i = 0; i < d.length; i += 4) {
      if (d[i + 3] < 150) continue;
      var r = d[i] / 255, g = d[i + 1] / 255, b = d[i + 2] / 255;
      var mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2, c = mx - mn;
      all++;
      if (c < 0.12 || l < 0.08 || l > 0.94) continue;
      var s = c / (1 - Math.abs(2 * l - 1)), hh;
      if (mx === r) hh = ((g - b) / c) % 6; else if (mx === g) hh = (b - r) / c + 2; else hh = (r - g) / c + 4;
      hh = (hh * 60 + 360) % 360;
      var wt = c * (0.6 + s * 0.4);
      var k = Math.floor(hh / 10) % 36;
      bins[k] += wt; ss[k] += s * wt;
      sx[k] += Math.cos(hh * Math.PI / 180) * wt; sy[k] += Math.sin(hh * Math.PI / 180) * wt;
      tot += wt;
    }
    if (!all) return null;
    // too little colour in the bottle: slate
    if (tot / all < 0.012) return [212, 0.08];
    var best = 0;
    for (i = 0; i < 36; i++) {
      var sc = bins[i] + 0.5 * (bins[(i + 35) % 36] + bins[(i + 1) % 36]);
      var bs = bins[best] + 0.5 * (bins[(best + 35) % 36] + bins[(best + 1) % 36]);
      if (sc > bs) best = i;
    }
    var X = 0, Y = 0, S = 0, W = 0;
    [(best + 35) % 36, best, (best + 1) % 36].forEach(function (k) { X += sx[k]; Y += sy[k]; S += ss[k]; W += bins[k]; });
    var hue = (Math.atan2(Y, X) * 180 / Math.PI + 360) % 360;
    var sat = Math.max(0.42, Math.min(0.66, (S / W) * 0.8));
    return [Math.round(hue), +sat.toFixed(2)];
  };
  $$('[data-niche]').forEach(function (el) {
    var src = el.getAttribute('data-niche');
    if (!src || src.length < 8) return;
    var key = 'azn3:' + src.split('?')[0].split('/').pop();
    try {
      var hit = sessionStorage.getItem(key);
      if (hit) { tint(el, JSON.parse(hit)); return; }
    } catch (e) {}
    var go = function () {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.decoding = 'async';
      im.onload = function () {
        try {
          var c = sample(im);
          if (!c) return;
          tint(el, c);
          try { sessionStorage.setItem(key, JSON.stringify(c)); } catch (e) {}
        } catch (e) {}
      };
      im.src = src;
    };
    if ('IntersectionObserver' in window) {
      var o = new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) { o.disconnect(); go(); }
      }, { rootMargin: '400px 0px' });
      o.observe(el);
    } else go();
  });

  /* 10 --------------------------------------------------------- rails
     The Just landed row scrolls sideways; the arrow pills move it one
     screenful and switch off at either end. */
  $$('[data-room-rail]').forEach(function (rail) {
    var track = $('[data-rail-track]', rail), prev = $('[data-rail-prev]', rail), next = $('[data-rail-next]', rail);
    if (!track || !prev || !next) return;
    var step = function () { return Math.max(200, track.clientWidth * 0.9); };
    var state = function () {
      prev.disabled = track.scrollLeft < 8;
      next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 8;
    };
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: still ? 'auto' : 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: still ? 'auto' : 'smooth' }); });
    track.addEventListener('scroll', function () { requestAnimationFrame(state); }, { passive: true });
    addEventListener('resize', state);
    state();
  });

  /* 11 -------------------------------------------------------- Tabby line
     Tabby's widget draws a white box inside its own shadow root. On the
     product page it sits right under the price, so it is restyled here into
     one quiet line in the room's type and colours (its words, amounts, logo
     and Learn more stay exactly as Tabby prints them). The selectors match
     the BEM names, not the hashed suffixes, so a Tabby update keeps working. */
  var tabbyCss = '[class*="SnippetWrapper__Content"],[class*="SnippetDefault__SnippetDefault--"]{background:transparent!important;border:0!important;border-radius:0!important;box-shadow:none!important;min-height:0!important;max-width:none!important}' +
    '[class*="SnippetDefault__Content"]{padding:0!important;align-items:center!important;gap:10px}' +
    '[class*="SnippetDefault__Logo"]{width:46px!important;order:-1;align-self:center!important}' +
    '[class*="SnippetContent__SnippetContent--"]{margin:0!important;flex-direction:row!important;align-items:center}' +
    '[class*="SnippetContent__Text"],[class*="Text__Text--"]{color:rgba(239,229,214,.72)!important;font-family:"Instrument Sans",system-ui,sans-serif!important;font-size:13px!important;line-height:19px!important}' +
    'strong,[class*="TightBold"]{color:#EFE5D6!important;font-weight:500!important}' +
    '[class*="SnippetContent__Link"]{color:#EFE5D6!important;margin:0 0 0 2px!important;text-decoration:underline!important;text-underline-offset:3px}';
  var tame = function (root) {
    if (!root || root.querySelector('style[data-room]')) return;
    var st = document.createElement('style');
    st.setAttribute('data-room', '');
    st.textContent = tabbyCss;
    root.appendChild(st);
  };
  /* Tabby replaces its own #TabbyPromo element as it loads, so the look-up
     is fresh every time and the watch sits on our own wrapper (.pdp-app) */
  var appBox = $('.room-pdp .pdp-app');
  if (appBox && 'MutationObserver' in window) {
    var sweep = function () {
      $$('*', appBox).forEach(function (el) {
        if (!el.shadowRoot) return;
        tame(el.shadowRoot);
        if (el.shadowRoot.__roomWatch) return;
        el.shadowRoot.__roomWatch = 1;
        new MutationObserver(function () { tame(el.shadowRoot); }).observe(el.shadowRoot, { childList: true });
      });
    };
    new MutationObserver(sweep).observe(appBox, { childList: true, subtree: true });
    sweep();
    /* a shadow root attached to an element already on the page fires no
       mutation, so look again every quarter second for the first 30 seconds */
    var looks = 0, look = setInterval(function () { sweep(); if (++looks > 120) clearInterval(look); }, 250);
  }

  /* 12 ------------------------------------------------------ Houses A-Z
     The letter you tap turns dark in the A-Z capsule (the directory runs in
     columns, so the scroll position cannot say which letter you are on). */
  var azBar = $('.hz-az-pill');
  if (azBar) {
    azBar.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a) return;
      $$('a', azBar).forEach(function (x) { x.classList.toggle('is-on', x === a); });
    });
  }

  /* 13 ------------------------------------------------------- gift amount
     The cream card and the pill show the amount picked, cross-blurred in
     place (transitions.dev text swap soft). */
  var giftForm = $('form[data-gift]');
  if (giftForm) {
    var giftShow = function () {
      var picked = giftForm.querySelector('input[name="id"]:checked');
      if (!picked) return;
      var label = picked.parentElement.querySelector('span');
      var text = label ? label.textContent.trim() : '';
      $$('[data-gift-amount]').forEach(function (el) {
        if (el.textContent.trim() === text) return;
        if (still) { el.textContent = text; return; }
        el.style.transition = 'opacity 150ms ease, filter 150ms ease';
        el.style.opacity = '0'; el.style.filter = 'blur(2px)';
        setTimeout(function () { el.textContent = text; el.style.opacity = '1'; el.style.filter = 'blur(0)'; }, 150);
      });
    };
    giftForm.addEventListener('change', function (e) { if (e.target.name === 'id') giftShow(); });
    giftShow();
  }

  /* 14 ------------------------------------------------------ guides index
     Each guide in the admin list is written "Link: what it covers". The
     row shows the link as the title, the words after the colon under it,
     and a "Read" pill on the right. Without script it stays a plain list. */
  $$('.pp--guides > ul > li').forEach(function (li) {
    var a = li.firstElementChild;
    if (!a || a.tagName !== 'A' || li.querySelector('.gl-read')) return;
    var rest = li.textContent.replace(a.textContent, '').replace(/^\s*[:–—-]\s*/, '').trim();
    a.classList.add('gl-title');
    li.innerHTML = '';
    var box = document.createElement('div');
    box.appendChild(a);
    if (rest) {
      var d = document.createElement('span');
      d.className = 'gl-desc';
      d.textContent = rest.charAt(0).toUpperCase() + rest.slice(1);
      box.appendChild(d);
    }
    li.appendChild(box);
    var go = document.createElement('a');
    go.className = 'pill gl-read';
    go.href = a.getAttribute('href');
    go.tabIndex = -1;
    go.setAttribute('aria-hidden', 'true');
    go.innerHTML = '<span class="pill-l">Read</span><span class="pill-c pill-c--ico">&rarr;</span>';
    li.appendChild(go);
  });

  /* 15 ---------------------------------------------------- guide contents
     The contents list is built from the article's own section headings, and
     the one being read is marked as you scroll. */
  var toc = $('.gd-toc');
  var prose = $('.gd-prose');
  if (toc && prose) {
    var hs = $$(':scope > h2', prose);
    if (hs.length >= 2) {
      var list = $('ol', toc);
      hs.forEach(function (h, i) {
        if (!h.id) h.id = 'g-' + (i + 1) + '-' + h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40);
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent.trim();
        li.appendChild(a);
        list.appendChild(li);
      });
      toc.hidden = false;
      if ('IntersectionObserver' in window) {
        var links = $$('a', toc);
        var tio = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (!e.isIntersecting) return;
            links.forEach(function (l) { l.classList.toggle('is-on', l.getAttribute('href') === '#' + e.target.id); });
          });
        }, { rootMargin: '-15% 0px -70% 0px' });
        hs.forEach(function (h) { tio.observe(h); });
      }
    }
  }

  /* 6 ---------------------------------------------------------- WhatsApp */
  var ask = $('#ask-float');
  var foot = $('.room-foot');
  if (ask && foot && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      if (es[0].isIntersecting) ask.setAttribute('data-away', ''); else ask.removeAttribute('data-away');
    }).observe(foot);
  }

  /* 8 ---------------------------------------------------------- product pill
     theme.js rewrites #pdp-now when a size is picked; the buy pill carries
     the same price, so it follows. */
  var now = $('#pdp-now');
  if (now && 'MutationObserver' in window) {
    new MutationObserver(function () {
      var p = $('#pdp-cart [data-room-price]');
      if (p) p.textContent = now.textContent;
    }).observe(now, { childList: true, characterData: true, subtree: true });
  }

  /* 9 ---------------------------------------------------------- seat bottles
     Cut-outs come from many sources and their glass ends at different
     heights inside the picture, so some bottles looked as if they hovered
     over the stone. A 120 px copy of each picture (same origin, a few KB,
     cached) is read once: the lowest solid row is where the glass meets
     the counter. The bottle moves down so that row lands on the counter
     line (96.8% of its box, where the cast shadow is pinned), and the
     contact shadow is sized to the width of the base. */
  var seat = function (rb) {
    var img = $('.rb-img', rb);
    if (!img || rb.dataset.seated) return;
    rb.dataset.seated = 1;
    var src = img.getAttribute('src') || '';
    if (!src) return;
    var small = src.replace(/([?&])width=\d+/, '$1width=120');
    if (small === src) small += (src.indexOf('?') < 0 ? '?' : '&') + 'width=120';
    var key = 'azb2:' + small.split('?')[0].split('/').pop();
    var apply = function (m) {
      if (!m) return;
      rb.style.setProperty('--drop', m[0] + '%');
      rb.style.setProperty('--cl', m[1] + '%');
      rb.style.setProperty('--cr', m[2] + '%');
      if (m[3]) rb.style.setProperty('--base', m[3] + '%');
    };
    try { var hit = sessionStorage.getItem(key); if (hit) { apply(JSON.parse(hit)); return; } } catch (e) {}
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var w = im.naturalWidth, h = im.naturalHeight;
        // the box is 3:4; measure in that frame (object-fit: contain)
        var bw = 90, bh = 120, s = Math.min(bw / w, bh / h);
        var dw = w * s, dh = h * s, ox = (bw - dw) / 2, oy = (bh - dh) / 2;
        var cv = document.createElement('canvas');
        cv.width = bw; cv.height = bh;
        var cx = cv.getContext('2d', { willReadFrequently: true });
        cx.drawImage(im, ox, oy, dw, dh);
        var d = cx.getImageData(0, 0, bw, bh).data;
        var need = Math.max(2, Math.round(bw * 0.03)), base = -1, x, y, n;
        for (y = bh - 1; y >= 0 && base < 0; y--) {
          for (n = 0, x = 0; x < bw; x++) if (d[(y * bw + x) * 4 + 3] > 60) n++;
          if (n >= need) base = y;
        }
        if (base < 0) return;
        var l = bw, r = -1;
        for (y = Math.max(0, base - 3); y <= base; y++) {
          for (x = 0; x < bw; x++) if (d[(y * bw + x) * 4 + 3] > 60) { if (x < l) l = x; if (x > r) r = x; }
        }
        var fromBottom = (bh - 1 - base) / bh;
        var drop = Math.max(-4, Math.min(30, (fromBottom - 0.032) * 100));
        var m = [drop.toFixed(2), Math.max(0, l / bw * 100 - 3).toFixed(1), Math.max(0, (bw - 1 - r) / bw * 100 - 3).toFixed(1), (fromBottom * 100).toFixed(2)];
        apply(m);
        try { sessionStorage.setItem(key, JSON.stringify(m)); } catch (e) {}
      } catch (e) {}
    };
    im.src = small;
  };
  var rbs = $$('.rb');
  if ('IntersectionObserver' in window) {
    var so = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { so.unobserve(e.target); seat(e.target); } });
    }, { rootMargin: '600px 0px' });
    rbs.forEach(function (rb) { so.observe(rb); });
  } else rbs.forEach(seat);

  /* 7 ---------------------------------------------------------- bag bump */
  var count = $('#bag-count');
  if (count && 'MutationObserver' in window && !still) {
    var was = count.textContent;
    new MutationObserver(function () {
      if (count.textContent === was) return;
      var up = parseInt(count.textContent, 10) > parseInt(was, 10);
      was = count.textContent;
      if (!up) return;
      var bag = count.closest('.room-bag') || count;
      bag.classList.remove('is-bumped');
      void bag.offsetWidth;
      bag.classList.add('is-bumped');
    }).observe(count, { childList: true, characterData: true, subtree: true });
  }
})();
